import React from "react";
import { useNavigate } from "react-router-dom";

const getStatusColor = (status) => {
  switch (status) {
    case "online":
      return "green";
    case "warning":
      return "orange";
    case "offline":
      return "red";
    case "unclaimed":
      return "gray";
    default:
      return "gray";
  }
};

const formatLastSeen = (seconds) => {
  if (seconds == null) return "—";
  if (seconds < 5) return "now";
  if (seconds < 60) return `${seconds}s`;
  return `${Math.floor(seconds / 60)}m`;
};

const DeviceRow = ({ device, onRetire, onRelease, onMove }) => {
  const navigate = useNavigate();

  return (
    <div className="pm-row">
      <div>{device.deviceName || device.deviceId}</div>

      <div>{device.orgName || "—"}</div>

      <div>
        <span
          style={{
            color: getStatusColor(device.status),
            fontWeight: "bold",
          }}
        >
          ● {device.status === "registered-inactive" ? "Registered / Inactive" : device.status}
        </span>
      </div>

      <div>{formatLastSeen(device.lastSeenSecondsAgo)}</div>

      <div>{device.printerCount || 0}</div>

      <div>{device.queueDepth || 0}</div>

      <div>
        <button onClick={() => navigate(`/devices/${device.deviceId}`)}>
          View
        </button>
        {onRetire && device.status !== "retired" && <button onClick={()=>onRetire(device)}>Retire</button>}
        {onMove && device.status !== 'retired' && <button onClick={()=>onMove(device)}>Move to Another Organization</button>}
        {onRelease && device.status !== 'retired' && <button onClick={()=>onRelease(device)}>Release Device</button>}
      </div>
    </div>
  );
};

export default DeviceRow;
